import React, { useState, useEffect, useContext } from 'react';
import { Paper, Box, Grid, Chip, Typography, Autocomplete, CircularProgress, InputAdornment, TextField, IconButton, Pagination } from '@mui/material';
import ApiService from '../../functions/apiService';
import ButtonDatePicker from '../../components/DatePickers/ButtonDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import moment from 'moment';
import MyTable from '../../components/Schedule/MyTable';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import './position-assign.css'
import SearchIcon from "@mui/icons-material/Search";
import { toast } from 'react-toastify';
import { Col, Row } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { varFormatTime } from '../../utils/helperFunctions';
import AuthContext from '../../context/AuthContext';
import editIcon from "../../assets/edit.svg";
import { DataGrid } from '@mui/x-data-grid';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Multiselect from 'multiselect-react-dropdown';

const PositionAssignment = () => {
    const { user } = useContext(AuthContext)
    const [loading, setLoading] = useState(false);
    const [date, setDate] = useState(new Date());
    const [deleteModal, setDeleteModal] = useState(false)
    const [assignmentDrop, setAssignmentDrop] = useState([]);
    const [assignment, setAssignment] = useState('');
    const [assignmentList, setAssignmentList] = useState('');
    const [searchResult, setSearchResult] = useState('');
	const [position, setPosition] = useState(null);
	const [positionDrop, setPositionDrop] = useState([]);
	const [group, setGroup] = useState(null);
	const [groupDrop, setGroupDrop] = useState([]);
	const [battalion, setBattalion] = useState(null);
	const [battalionDrop, setBattalionDrop] = useState([]);
	const [district, setDistrict] = useState(null);
	const [districtDrop, setDistrictDrop] = useState([]);
	const [vehicle, setVehicle] = useState(null);
	const [vehicleDrop, setVehicleDrop] = useState([]);
	const [shift, setShift] = useState(null);
	const [shiftDrop, setShiftDrop] = useState([]);
	const [assignId, setAssignId] = useState(null);
	const [deleteId, setDeleteId] = useState('');
	const [isEdit, setIsEdit] = useState(false);
    const [endDate, setEndDate] = useState(null);
    const [createRotationModal , setCreateRotationModal] = useState(false);
    const [effectiveDate , setEffectiveDate] = useState(new Date());
    const [endDatePopup, setEndDatePopup] = useState(null);
    const [rotationDays , setRotationDays] = useState('');
    const [employees , setEmployees] = useState([]);
    const [selectedEmp , setSelectedEmp] = useState([]);
    const [selectedPosAssignment , setSelectedPosAssignment] = useState([]);
    const [viewRotationModal , setViewRotationModal] = useState(false);
    const [selectedEmployees , setSelectedEmployees] = useState([]);

    const columns = [
			{
            field: 'action', headerName: 'Actions', flex: 1, minWidth: 130,
            renderCell: (params) => {
                return (
                    <Box sx={{ display: 'flex', gap: 1 }}>
          							<img src={editIcon} alt="editIcon" style={{width: '20px', cursor: 'pointer'}}
												 onClick={() => {
															getAssignmentData(params?.row?.ID)
															setAssignId(params?.row?.ID)
															setIsEdit(true)
															window.scrollTo(1,1)
															}} 
												/>
                        <img src='/images/delete.svg' style={{ cursor: 'pointer' }}
                            onClick={() => {
															setDeleteId(params?.row?.ID)
                              setDeleteModal(true)
                            }}
                        />
                    </Box>
                );
            },
        },

				{
            field: 'Assignment_date', headerName: 'Effective Date', flex: 1, minWidth: 200,
            valueGetter: (params) => {
                return moment(params?.row?.Effective_Date).format('MM/DD/YY');
            }
        },
				
				{
						field: 'Assignment', headerName: 'Assignment', flex: 1, minWidth: 200,
						renderCell: (params) => {
								return (
									params?.row?.Assignment_Name
								)
						}
				},

				{
            field: 'Position', headerName: 'Position', flex: 1, minWidth: 200,
            valueGetter: (params) => { 
							return (params?.row?.Position_Name)
						}
        },

				{
            field: 'Shift', headerName: 'Shift', flex: 1, minWidth: 200,
            renderCell: (params) => {
                return (
									params?.row?.Shift_Name
                )
            }
        },

				{
            field: 'Vehicle', headerName: 'Vehicle', flex: 1, minWidth: 200,
            renderCell: (params) => {
                return (
									params?.row?.Vehicle_Name
                )
            }
        },

        {
            field: 'Group', headerName: 'Group', flex: 1, minWidth: 200,
            renderCell: (params) => {
                return (
									params?.row?.Group_Name
                )
            }
        },

				{
            field: 'Battalion', headerName: 'Battalion', flex: 1, minWidth: 200,
            renderCell: (params) => {
                return (
									params?.row?.Batallion_Name
                )
            }
        },

				{
            field: 'District', headerName: 'District', flex: 1, minWidth: 200,
            renderCell: (params) => {
                return (
									params?.row?.District_Name
                )
            }
        },

				{
            field: 'End_date', headerName: 'End Date', flex: 1, minWidth: 200,
            valueGetter: (params) => {
							return params?.row?.End_Date 
              ? moment(params?.row?.End_Date).format('MM/DD/YY')
							: "" ;
						}
        },
    ]

	const addAssignment = () => {
        const body = {
						"Effective_Date" : moment(date).format('YYYY-MM-DD'),
						"End_Date" : endDate ? moment(endDate).format('YYYY-MM-DD') : null,
						"Assignment_Code" : assignment?.value,
						"Position_Code" : position?.value,
						"Group_Code" : group?.value,
						"Battalion_Code" : battalion?.value,
						"District_Code" : district?.value,
						"Vehicle_Code" : vehicle?.value,
						"Shift_Code" : shift?.value
        }
        ApiService.post('/position-assignment/add', body)
            .then((data) => {
                toast.success(data?.message)
                setDate(new Date());
								setEndDate(null);
                setAssignment('');
								setPosition(null)
								setGroup(null)
								setBattalion(null)
								setDistrict(null)
								setVehicle(null)
								setShift(null)
                getAssignmentList()
            })
            .catch((error) => {
                if (error.status == 422) {
                    Object.keys(error.data.errors).map((err) => (
                        toast.error(error.data.errors[err][0])
                    ))
                }
                else {
                    toast.error(error.message)
                }
            })
    }

		const getPositionDropown = () => {
			setLoading(true);
			ApiService.get('/positions-list')
				.then(({ data }) => {
					var certArr = data?.data.map((cer) => { return { label: cer.SO_Desc, value: cer.SO_Value } })
					setPositionDrop(certArr)
					setLoading(false);
				})
				.catch((e) => {
					setLoading(false);
				})
		}

		const getAssignmentDropDown = () => {
		setLoading(true);
		ApiService.get('/getAssignment')
				.then(({ data }) => {
						var assignArr = data?.data.map((assign) => { return { label: assign.SO_Desc, value: assign.SO_Value } })
						setAssignmentDrop(assignArr)
						setLoading(false);
				})
				.catch((e) => {
						setLoading(false);
				})
    }

		const getGroupDropDown = () => {
		setLoading(true);
		ApiService.get("/getGroups")
		.then(({ data }) => {
			var tempArr = []
			Object.keys(data?.data).map(val => (
				tempArr.push({label:data.data[val], value: val})
			))
			setGroupDrop(tempArr)
		})
		.catch((e) => {
			setLoading(false);
				})
    }

		const getBattalionDropDown = () => {
		setLoading(true);
		ApiService.get("/getBattalions")
		.then(({ data }) => {
				var batArr = data?.data.map((assign) => { return { label: assign.SO_Desc, value: assign.SO_Value } })
				setBattalionDrop(batArr);
		})
		.catch((e) => {
			setLoading(false);
				})
    }

		const getVehicleDropDown = () => {
		setLoading(true);
		ApiService.get("/getVehicles")
		.then(({ data }) => {
			var vehicleArr = data?.data.map((assign) => { return { label: assign.SO_Desc, value: assign.SO_Value } })
			setVehicleDrop(vehicleArr);
		})
		.catch((e) => {
			setLoading(false);
				})
    }

		const getAssignmentList = () => {
		ApiService.get('/position-assignment/list')
				.then((data) => {
						const rowsWithIds = data?.data?.data?.map((item, index) => ({
								...item,
								id: index + 1
						})) || [];
						setAssignmentList(rowsWithIds);
						setLoading(false);
				})
				.catch((e) => {
						setLoading(false);
				});
    };

    const deleteAssignment = () => {
        const body = {
            'id': deleteId,
        }
        ApiService.post('/position-assignment/delete', body)
            .then((data) => {
                setDeleteModal(false)
                toast.success(data.message)
                getAssignmentList()
            })
            .catch((err) => {
                toast.error(err?.data?.error)
            })
    }

		const getShiftDropDown = () => {
		ApiService.get('/shiftTypes')
				.then((data) => {
					var shiftArr = data?.data?.data?.map((shift) => { return { label: shift.Shift + " (" + shift.Start_Time?.slice(0,5) + " - " + shift.End_Time?.slice(0,5) + ")", value: shift.ShiftCode } })
					// var shiftArr = data?.data?.data?.map((shift) => ({
    			// label: `${shift.Shift} (${varFormatTime(shift.Start_Time, user?.Time_Format)?.slice(0,5)} - ${varFormatTime(shift.End_Time, user?.Time_Format)?.slice(0,5)})`,
    			// value: shift.ShiftCode
					// }));
					setShiftDrop(shiftArr)
					setLoading(false);
				})
				.catch((err) => {
						console.log(err?.data?.error)
				})
    }

		const updateAssignment = () => {
		const body = {
				"id" : assignId,
				"Effective_Date" : moment(date).format('YYYY-MM-DD'),
				"End_Date" : endDate ? moment(endDate).format('YYYY-MM-DD') : null,
				"Assignment_Code" : assignment?.value,
				"Position_Code" : position?.value,
				"Group_Code" : group?.value,
				"Battalion_Code" : battalion?.value,
				"District_Code" : district?.value,
				"Vehicle_Code" : vehicle?.value,
				"Shift_Code" : shift?.value
		}
		ApiService.post('/position-assignment/update', body)
				.then((data) => {
						toast.success(data?.message)
						setIsEdit(false)
						setDate(new Date());
						setEndDate(null);
						setAssignment('');
						setPosition(null)
						setGroup(null)
						setBattalion(null)
						setDistrict(null)
						setVehicle(null)
						setShift(null)
						getAssignmentList()
				})
				.catch((error) => {
						if (error.status == 422) {
								Object.keys(error.data.errors).map((err) => (
										toast.error(error.data.errors[err][0])
								))
						}
						else {
								toast.error(error.message)
						}
				})
    }

		const getAssignmentData = (id) => {
    if (id) {
		ApiService.get('/position-assignment/show/' + id)
				.then((data) => {
					setLoading(false);
					setDate(new Date(data?.data?.position_assignment?.Effective_Date + "T12:00:00"))
					setEndDate(data?.data?.position_assignment?.End_Date == null ? null : new Date(data?.data?.position_assignment?.End_Date + "T12:00:00"))
					var tempAssign = assignmentDrop.find(a => a.value == data?.data?.position_assignment?.Assignment_Code)
					setAssignment(tempAssign)
					var tempPos = positionDrop.find(a => a.value == data?.data?.position_assignment?.Position_Code)
					setPosition(tempPos)
					var tempGroup = groupDrop.find(a => a.value == data?.data?.position_assignment?.Group_Code)
					setGroup(tempGroup)
					var tempBatt = battalionDrop.find(a => a.value == data?.data?.position_assignment?.Batallion_Code)
					setBattalion(tempBatt)
					var tempDis = districtDrop.find(a => a.value == data?.data?.position_assignment?.District_Code)
					setDistrict(tempDis)
					var tempVeh = vehicleDrop.find(a => a.value == data?.data?.position_assignment?.Vehicle_Code)
					setVehicle(tempVeh)
					var tempShift = shiftDrop.find(a => a.value == data?.data?.position_assignment?.Shift_Code)
					setShift(tempShift)
				})
				.catch((error) => {
						toast.error(error.message)
      			setLoading(false);
				})
			}
    }

    useEffect(() => {
        getAssignmentList()
        getAssignmentDropDown()
				getPositionDropown()
				getGroupDropDown()
				getVehicleDropDown()
				getBattalionDropDown()
				getShiftDropDown()
    }, [])

    useEffect(() => {
        getAssignmentList(false)
    }, [searchResult])

    const loadEmployees = () => {
        ApiService.get('/employees-list?search=')
            .then(({ data }) => {
            var tempArr = []
            data.data.map((emp) => {
                var obj = emp
                obj.label = `${emp.employee_assignment.EA_Rank} ${emp.fullName} (Seniority : ${emp?.EHd_Seniority})`
                tempArr.push(obj)
            })
                setEmployees(tempArr)
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
            })
    }

    useEffect(()=>{
        loadEmployees()
    }, [])

    const RotationCalled = () => {
        const body = {
            "Rotation_Id" : selectedPosAssignment?.Rotation?.Id,
            "Position_Assignment_ID": selectedPosAssignment?.ID,
            "Employees": selectedEmp.map((a) => { return a.Emp_Code }),
            "Rotation_Days": parseInt(rotationDays, 10),
            "Effective_Date": moment(effectiveDate).format('YYYY-MM-DD'),
            "End_Date": endDatePopup ? moment(endDatePopup).format('YYYY-MM-DD') : null
        }
        ApiService.post('/position-assignment-rotation', body)
            .then((data) => {
                setCreateRotationModal(false);
                setViewRotationModal(false);
                setEffectiveDate(null)
                setEndDatePopup(null)
                setSelectedEmp([]);
                setRotationDays('');
                toast.success(data.message)
                getAssignmentList()
            })
            .catch((err) => {
                toast.error(err?.data?.message || err?.data?.errors)
            })
    }

    useEffect(() => {
        if(selectedPosAssignment.Rotation){
            const empCodesStr = selectedPosAssignment?.Rotation?.Employees; 
                if (!empCodesStr) return;

                const codes = empCodesStr.split(",").map(c => c.trim());

                const matched = employees
                    ?.filter(emp => codes.includes(String(emp.Emp_Code)))
                    ?.sort((a, b) => Number(b.EHd_Seniority) - Number(a.EHd_Seniority));

                setSelectedEmp(matched);
                // setEffectiveDate(selectedPosAssignment?.Rotation?.Effective_Date ? new Date(selectedPosAssignment.Rotation.Effective_Date) : null)
                setEndDatePopup(selectedPosAssignment?.Rotation?.End_Date ? new Date(selectedPosAssignment.Rotation.End_Date) : null);
                setRotationDays(selectedPosAssignment?.Rotation?.Rotation_Days)
            }
    }, [selectedPosAssignment, employees]);


    return (
        <>
            <Paper className="p-4 font-fam" style={{ marginTop: "1rem" }}>
                <Grid container spacing={2} className='align-items-center'>

                    {/* Heading */}
                    <Grid item xs={10} md={4}>
                        <Typography variant="h5">Position Assignment</Typography>
                    </Grid>

                    <Grid container className='p-4' spacing={2}>
                        
												{/* Effective Date */}
                        <Grid item xs={12} sm={6} md={4} className='d-grid'>
                            <label className='my-2'>Effective Date</label>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <ButtonDatePicker
                                    className='w-100'
                                    label={moment(date).format('MM/DD/YYYY')}
                                    value={date}
                                    onChange={(e) => setDate(e)}
                                />
                            </LocalizationProvider>
                        </Grid>

                        {/* Assignment */}
                        <Grid item xs={12} sm={6} md={4}>
                            <label className='my-2'>Assignment</label>
                            <Autocomplete
                                options={assignmentDrop}
                                onChange={(event, newValue) => setAssignment(newValue)}
                                value={assignment}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select Assignment"
                                        variant="outlined"
                                        fullWidth
                                        size="small"
                                        sx={{
                                            "& .MuiInputBase-root": {
                                                height: "48px",
                                                fontSize: "14px",
                                                display: "flex",
                                                alignItems: "center"
                                            }
                                        }}
                                    />
                                )}
                            />
                        </Grid>

												{/* Position */}
                        <Grid item xs={12} sm={6} md={4}>
                            <label className='my-2'>Position</label>
                            <Autocomplete
															options={positionDrop}
															onChange={(event, newValue) => setPosition(newValue)}
															value={position}
															renderInput={(params) => (
																<TextField
																	{...params}
																	placeholder="Select Position"
																		sx={{
																				"& .MuiInputBase-root": {
																					height: "48px",
																					fontSize: "14px",
																					display: "flex",
																					alignItems: "center"
																				}
																		}}
																/>
															)}
														/>
                        </Grid>

												{/* Group */}
												{groupDrop?.length > 0 &&
                        <Grid item xs={12} sm={6} md={4}>
                            <label className='my-2'>Group</label>
                            <Autocomplete
                                options={groupDrop}
                                onChange={(event, newValue) => setGroup(newValue)}
                                value={group}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select Group"
                                        variant="outlined"
                                        fullWidth
                                        size="small"
                                        sx={{
                                            "& .MuiInputBase-root": {
                                                height: "48px",
                                                fontSize: "14px",
                                                display: "flex",
                                                alignItems: "center"
                                            }
                                        }}
                                    />
                                )}
                            />
                        </Grid>}

												{/* Battalion */}
												{battalionDrop?.length > 0 &&
                        <Grid item xs={12} sm={6} md={4}>
                            <label className='my-2'>Battalion</label>
                            <Autocomplete
                                options={battalionDrop}
                                onChange={(event, newValue) => setBattalion(newValue)}
                                value={battalion}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select Battalion"
                                        variant="outlined"
                                        fullWidth
                                        size="small"
                                        sx={{
                                            "& .MuiInputBase-root": {
                                                height: "48px",
                                                fontSize: "14px",
                                                display: "flex",
                                                alignItems: "center"
                                            }
                                        }}
                                    />
                                )}
                            />
                        </Grid>}

												{/* District */}
												{districtDrop?.length > 0 &&
                        <Grid item xs={12} sm={6} md={4}>
                            <label className='my-2'>District</label>
                            <Autocomplete
                                options={districtDrop}
                                onChange={(event, newValue) => setDistrict(newValue)}
                                value={district}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select District"
                                        variant="outlined"
                                        fullWidth
                                        size="small"
                                        sx={{
                                            "& .MuiInputBase-root": {
                                                height: "48px",
                                                fontSize: "14px",
                                                display: "flex",
                                                alignItems: "center"
                                            }
                                        }}
                                    />
                                )}
                            />
                        </Grid>}

												{/* Vehicle */}
												{vehicleDrop.length > 0 &&
												<Grid item xs={12} sm={6} md={4}>
													<label className='my-2'>Vehicle</label>
													<Autocomplete
															options={vehicleDrop}
															onChange={(event, newValue) => setVehicle(newValue)}
															value={vehicle}
															renderInput={(params) => (
																	<TextField
																			{...params}
																			placeholder="Select Vehicle"
																			variant="outlined"
																			fullWidth
																			size="small"
																			sx={{
																					"& .MuiInputBase-root": {
																							height: "48px",
																							fontSize: "14px",
																							display: "flex",
																							alignItems: "center"
																					}
																			}}
																	/>
															)}
														/>
												</Grid>}

												{/* Shift Rotation */}
												{shiftDrop.length > 0 &&
												<Grid item xs={12} sm={6} md={4}>
													<label className='my-2'>Shift Rotation</label>
													<Autocomplete
															options={shiftDrop}
															onChange={(event, newValue) => setShift(newValue)}
															value={shift}
															renderInput={(params) => (
																	<TextField
																			{...params}
																			placeholder="Select Shift"
																			variant="outlined"
																			fullWidth
																			size="small"
																			sx={{
																					"& .MuiInputBase-root": {
																							height: "48px",
																							fontSize: "14px",
																							display: "flex",
																							alignItems: "center"
																					}
																			}}
																	/>
															)}
														/>
												</Grid>}

												{/* End Date */}
                        <Grid item xs={12} sm={6} md={4} className='d-grid'>
                            <label className='my-2'>End Date</label>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <ButtonDatePicker
                                    className='w-100'
                                    label={endDate ? moment(endDate).format('MM/DD/YYYY') : 'MM/DD/YYYY'}
                                    value={endDate}
                                    onChange={(e) => setEndDate(e)}
                                />
                            </LocalizationProvider>
                        </Grid>
                    </Grid>

                    {/* Submit/Edit Button */}
                    <Grid container gap={2} className='justify-content-end'>
                        <Grid item xs={6} md={'auto'}>
                            <ButtonTheme 
															className='px-2 mt-1' 
															style={{ marginRight: '24px' }}
															color='primary'
															type='submit' 
															variant="filled" 
                              onClick={() => 
																{if (isEdit == true)
																	updateAssignment()

																else 
																	addAssignment()
																}
															}
                            >
                                {isEdit == true ? "Update" : "Submit"}
                            </ButtonTheme>
                        </Grid>

                    </Grid>
                </Grid>
            </Paper>

            {loading ? (
                <Paper className="w-100 h-100 d-flex justify-content-center align-items-center font-fam">
                    <CircularProgress />
                </Paper> 
            ) : (
                <Paper className="p-4 font-fam" style={{ marginTop: "1rem" }}>
                    <Grid container spacing={2}>

                        {/* Heading */}
                        <Grid item xs={10} md={9}>
                            <Typography variant="h5">List of Position Assignment</Typography>
                        </Grid>

                        {/* Search field */}
                        {/* <Grid item xs={12} sm={12} md={3}>
                            <TextField
                                variant="outlined"
                                placeholder="Search"
                                onChange={(e) => setSearchResult(e.target.value)}
                                className="w-100"
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton>
                                                <SearchIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                    sx: {
                                        height: '48px',
                                        fontSize: '14px',
                                        marginRight: '10px',
                                    },
                                }}
                            />
                        </Grid> */}

                    </Grid>

                    {(!assignmentList || assignmentList.length == 0) ?
                        <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 325 }}>
                            <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                            <span className='mt-4' style={{ color: '#555555' }}>
                                No Positions assigned
                            </span>
                        </div>
                        :
                        <>
                            <Grid container spacing={2} className="mb-3 mt-1">
                                {assignmentList?.map((obj) => (
                                    <Grid item xs={12} sm={12} md={4}>
                                        <Box
                                            sx={{
                                                padding: '16px',
                                                backgroundColor: '#ffffff',
                                                borderRadius: '12px',
                                                border: '1px solid #EBECF0',
                                                height:'190px',
                                                overflow:'hidden',
                                                boxShadow: `
                                                0px 3.26px 9.79px rgba(31, 64, 148, 0.02),
                                                0px 6.53px 7.18px rgba(22, 38, 61, 0.06),
                                                0px 1.96px 3.92px rgba(4, 43, 141, 0.03)
                                            `,
                                            }}
                                        >
                                            <TableContainer>
                                                <Table aria-label="simple table">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell align="left" style={{ padding: '0px', paddingBottom: '6px', fontSize: '16px', fontFamily: 'karla' , display:'flex' , justifyContent:'space-between' }}>
                                                                <div>
                                                                     <Chip
                                                                        style={{
                                                                            textAlign: 'center',
                                                                            padding: '6px 6px',
                                                                            color: '#000000',
                                                                            backgroundColor: obj?.Shift_Name === 'Day' ? 'rgba(255, 165, 0, 0.26)' : 'rgba(52, 152, 219, 0.16)',
                                                                            border: obj?.Shift_Name === 'Day' === 2 ? '1px solid rgba(255, 165, 0, 0.28)' : '1px solid rgba(52, 152, 219, 0.2)'
                                                                        }}
                                                                        label={obj?.Shift_Name || ''}
                                                                    />
                                                                </div>
                                                                <div style={{display:'flex' , justifyContent:'normal'}}>
                                                                    <div>
                                                                        <img src={editIcon} alt="editIcon" style={{width: '20px', cursor: 'pointer' , marginLeft:'10px' , marginTop:'6px'}}
                                                                            onClick={() => {
                                                                                getAssignmentData(obj?.ID)
                                                                                setAssignId(obj.ID)
                                                                                setIsEdit(true)
                                                                                window.scrollTo(1,1)
                                                                            }} 
                                                                        />
                                                                        <img src='/images/delete.svg' style={{ cursor: 'pointer' , marginTop:'6px' , marginRight:'10px' }}
                                                                            onClick={() => {
                                                                                setDeleteId(obj?.ID)
                                                                                setDeleteModal(true)
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    {obj?.Rotation == null && obj?.Shift_Code && obj?.Is_Rotation == true &&
                                                                        <div style={{padding:'4px 16px'  , borderRadius:'40px' , backgroundColor:'#BF1D2D' , color:'#ffffff' , cursor:'pointer' }}
                                                                            onClick={() => {
                                                                                setCreateRotationModal(true);
                                                                                setSelectedPosAssignment(obj);
                                                                                loadEmployees()
                                                                            }}
                                                                        >
                                                                        + Rotation
                                                                        </div>
                                                                    }
                                                                    {obj?.Rotation &&
                                                                        <div style={{padding:'4px 16px'  , borderRadius:'40px' , backgroundColor:'#BF1D2D' , color:'#ffffff' , cursor:'pointer' }}
                                                                            onClick={() => {
                                                                                setViewRotationModal(true);
                                                                                setSelectedPosAssignment(obj);
                                                                            }}
                                                                        >
                                                                            View
                                                                        </div>
                                                                    }
                                                                </div>
                                                                
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        <TableRow key={obj.Value} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                            <TableCell
                                                                component="th"
                                                                scope="row"
                                                                style={{
                                                                    padding: '0px',
                                                                    fontSize: '14px',
                                                                    fontFamily: 'karla',
                                                                    padding: '7px',
                                                                    color: '#555555',
                                                                }}
                                                            >

                                                                <p style={{ marginBottom: '3px' }}>
                                                                    Effective Date :
                                                                    <span style={{ color: '#000000', fontWeight: '400 !important', marginLeft:'4px' }}>
                                                                        {obj?.Effective_Date ? moment(obj?.Effective_Date).format('MM/DD/YYYY') : '-'}
                                                                    </span> , 
                                                                    End Date :
                                                                    <span style={{ color: '#000000', fontWeight: '400 !important', marginLeft:'4px' }}>
                                                                        {obj?.End_Date ? moment(obj?.End_Date).format('MM/DD/YYYY') : '-'}
                                                                    </span>
                                                                </p>

                                                                {obj?.Assignment_Name &&
                                                                    <p style={{ marginBottom: '3px' }}>
                                                                        Assignment :
                                                                        <span style={{ color: '#000000', fontWeight: '400 !important' , marginLeft:'4px' }}>
                                                                            {obj?.Assignment_Name || '-'}
                                                                        </span>
                                                                    </p>
                                                                }

                                                                {obj?.Position_Name &&
                                                                    <p style={{ marginBottom: '3px' }}>
                                                                        Position :
                                                                        <span style={{ color: '#000000', fontWeight: '400 !important' , marginLeft:'4px' }}>
                                                                            {obj?.Position_Name || '-'}
                                                                        </span> ,
                                                                    </p>
                                                                }

                                                                <p style={{ marginBottom: '3px' }}>
                                                                    {obj?.Vehicle_Name &&
                                                                        <>
                                                                            Vehicle :
                                                                            <span style={{ color: '#000000', fontWeight: '400 !important' , marginLeft:'4px' }}>
                                                                                {obj?.Vehicle_Name || '-'}
                                                                            </span> ,
                                                                        </>
                                                                    }
                                                                    
                                                                    {obj?.Group_Name && 
                                                                        <>
                                                                            Group :
                                                                            <span style={{ color: '#000000', fontWeight: '400 !important' , marginLeft:'4px' }}>
                                                                                {obj?.Group_Name || '-'}
                                                                            </span> ,
                                                                        </>
                                                                         
                                                                    }

                                                                    {obj?.Batallion_Name &&
                                                                        <>
                                                                            Battalion :
                                                                            <span style={{ color: '#000000', fontWeight: '400 !important' , marginLeft:'4px' }}>
                                                                                {obj?.Batallion_Name || '-'}
                                                                            </span> ,
                                                                        </>
                                                                    }

                                                                    {obj?.District_Name &&
                                                                        <>
                                                                            District :
                                                                            <span style={{ color: '#000000', fontWeight: '400 !important' , marginLeft:'4px' }}>
                                                                                {obj?.District_Name || '-'}
                                                                            </span>
                                                                        </>
                                                                    }      
                                                                </p>

                                                            </TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Box>
                                    </Grid>
                                ))}
                            </Grid>
                        </>
                    }

                    {/* Delete Modal */}
                    <Modal show={deleteModal} onHide={() => setDeleteModal(false)}>
                        <Modal.Header closeButton>
                            <Modal.Title>Delete Assignment</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                            <div style={{ color: '#555555' }}>
                                Are you sure you want to delete this Assignment?
                            </div>
                            <Row>
                                <Col md='auto'>
                                    <ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => {
                                        setDeleteModal(false)
                                    }}>
                                        Cancel
                                    </ButtonTheme>
                                </Col>

                                <Col md='auto'>
                                    <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4'
                                        onClick={deleteAssignment}
                                    >
                                        Delete
                                    </ButtonTheme>
                                </Col>

                            </Row>
                        </Modal.Body>
                    </Modal>

                    <Modal show={createRotationModal} size='md' onHide={() => {
                        setCreateRotationModal(false)
                        setEffectiveDate(null)
                        setEndDatePopup(null)
                        setSelectedEmp([])
                        setRotationDays('')
                    }}>
                        <Modal.Header closeButton>
                            <Modal.Title>Create Rotation</Modal.Title>
                        </Modal.Header>

                        <Modal.Body className='px-4'>
                            <Row>
                                <Col md={6} className='d-grid mt-2'>
                                    <label className='my-1'>Effective Date</label>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <ButtonDatePicker
                                            className='w-100'
                                            label= {effectiveDate ? moment(effectiveDate).format('MM/DD/YYYY') : "MM/DD/YYYY"}
                                            value={effectiveDate}  
                                            disablePast
                                            onChange={(date) => {
                                                setEffectiveDate(date);   
                                            }}
                                            // minDate={
                                            //     selectedPosAssignment?.Effective_Date
                                            //         ? moment(selectedPosAssignment.Effective_Date, "YYYY-MM-DD").toDate()
                                            //         : null
                                            // }
                                            // maxDate={
                                            //     selectedPosAssignment?.End_Date
                                            //         ? moment(selectedPosAssignment.End_Date, "YYYY-MM-DD").endOf("day").toDate()
                                            //         : null
                                            // }
                                        />

                                    </LocalizationProvider>
                                </Col>
                                <Col md={6} className='d-grid mt-2'>
                                    <label className='my-1'>End Date</label>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <ButtonDatePicker
                                            className='w-100'
                                            label= {endDatePopup ? moment(endDatePopup).format('MM/DD/YYYY') : "MM/DD/YYYY"}
                                            value={endDatePopup}   
                                            onChange={(date) => {
                                                setEndDatePopup(date);   
                                            }}
                                            disablePast
                                            // minDate={
                                            //     selectedPosAssignment?.Effective_Date
                                            //         ? moment(selectedPosAssignment.Effective_Date, "YYYY-MM-DD").toDate()
                                            //         : null
                                            // }
                                            // maxDate={
                                            //     selectedPosAssignment?.End_Date
                                            //         ? moment(selectedPosAssignment.End_Date, "YYYY-MM-DD").endOf("day").toDate()
                                            //         : null
                                            // }
                                        />
                                    </LocalizationProvider>
                                </Col>
                                <Col md={12} className='d-grid mt-2'>
                                    <label className='my-1'>Rotation Days ( Maximum : 7 )</label>
                                    <TextField
                                        fullWidth
                                        placeholder="Days"
                                        label="Days"
                                        type='number'
                                        InputProps={{
                                            inputProps: { min: 1, max: 7, step: 1 },
                                            sx: {
                                                height: '52px',
                                                fontSize: '14px'
                                            }
                                        }}
                                        value={rotationDays}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (value === '' || (Number(value) >= 1 && Number(value) <= 7)) {
                                                setRotationDays(value);
                                            }
                                        }}
                                    />
                                </Col>
                                <Col md={12} className='d-grid mt-2'>
                                    <label className='my-1'>Employess ( Maximum equal to the Rotation days )</label>
                                    <Multiselect
                                        displayValue="label"
                                        options={employees}
                                        showCheckbox
                                        showArrow
                                        customCloseIcon={<img src="/images/cross.png" alt="close" />}
                                        placeholder="Members"
                                        selectedValues={selectedEmp}
                                        onSelect={(e) => setSelectedEmp(e)}
                                        onRemove={(e) => setSelectedEmp(e)}
                                        style={{
                                            multiselectContainer: {
                                                width: "100%",
                                                height:'100%'
                                            },
                                            searchBox: {
                                                minHeight: "48px",
                                                height: "auto",
                                                display: "flex",
                                                flexWrap: "wrap",       
                                                alignItems: "flex-start",
                                            },
                                        }}
                                        customInputRenderer={(inputProps) => (
                                            <TextField
                                                {...inputProps}
                                                variant="outlined"
                                                fullWidth
                                                size="small"
                                                sx={{
                                                    "& .MuiInputBase-root": {
                                                        height: "48px",
                                                        fontSize: "14px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                    },
                                                }}
                                            />
                                        )}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col md='auto'>
                                    <ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => {
                                        setCreateRotationModal(false)
                                    }}>
                                        Cancel
                                    </ButtonTheme>
                                </Col>

                                <Col md='auto'>
                                    <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4'
                                        onClick={RotationCalled}
                                    >
                                        Save
                                    </ButtonTheme>
                                </Col>
                            </Row>
                        </Modal.Body>
                    </Modal>

                    <Modal show={viewRotationModal} size="md" onHide={() => {
                        setViewRotationModal(false)
                        setSelectedPosAssignment([])
                        setEffectiveDate(null)
                        setEndDatePopup(null)
                        setRotationDays('')
                        setSelectedEmp([])
                    }}>
                        <Modal.Header closeButton>
                            <Modal.Title>View/Update Rotation</Modal.Title>
                        </Modal.Header>

                        <Modal.Body className='px-4'>
                            <Row>
                                <Col md={6} className='d-grid mt-2'>
                                    <label className='my-1'>Effective Date</label>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <ButtonDatePicker
                                            className='w-100'
                                            label= {selectedPosAssignment?.Rotation?.Effective_Date ? moment(selectedPosAssignment?.Rotation?.Effective_Date).format('MM/DD/YYYY') : "MM/DD/YYYY"}
                                            // value={effectiveDate}   
                                            // onChange={(date) => {
                                            //     setEffectiveDate(date);   
                                            // }}
                                            disabled
                                            minDate={
                                                selectedPosAssignment?.Effective_Date
                                                    ? moment(selectedPosAssignment.Effective_Date, "YYYY-MM-DD").toDate()
                                                    : null
                                            }
                                            maxDate={
                                                selectedPosAssignment?.End_Date
                                                    ? moment(selectedPosAssignment.End_Date, "YYYY-MM-DD").endOf("day").toDate()
                                                    : null
                                            }
                                        />
                                    </LocalizationProvider>
                                </Col>
                                <Col md={6} className='d-grid mt-2'>
                                    <label className='my-1'>End Date</label>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <ButtonDatePicker
                                            className='w-100'
                                            label= {endDatePopup ? moment(endDatePopup).format('MM/DD/YYYY') : "MM/DD/YYYY"}
                                            value={endDatePopup}   
                                            onChange={(date) => {
                                                setEndDatePopup(date);   
                                            }}
                                            minDate={new Date()}
                                        />
                                    </LocalizationProvider>
                                </Col>
                                <Col md={12} className='d-grid mt-2'>
                                    <label className='my-1'>Rotation Days</label>
                                    <TextField
                                        fullWidth
                                        placeholder="Days"
                                        label="Days"
                                        type='number'
                                        InputProps={{
                                            inputProps: { min: 1, max: 7, step: 1 },
                                            sx: {
                                                height: '52px',
                                                fontSize: '14px'
                                            }
                                        }}
                                        value={rotationDays}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (value === '' || (Number(value) >= 1 && Number(value) <= 7)) {
                                                setRotationDays(value);
                                            }
                                        }}
                                    />
                                </Col>
                                <Col md={12} className='d-grid mt-2 mb-2'>
                                    <label className='my-1'>Employess </label>
                                    <Multiselect
                                        displayValue="label"
                                        options={employees}
                                        showCheckbox
                                        showArrow
                                        customCloseIcon={<img src="/images/cross.png" alt="close" />}
                                        placeholder="Members"
                                        selectedValues={selectedEmp}
                                        onSelect={(e) => setSelectedEmp(e)}
                                        onRemove={(e) => setSelectedEmp(e)}
                                        style={{
                                            multiselectContainer: {
                                                width: "100%",
                                                height:'100%'
                                            },
                                            searchBox: {
                                                minHeight: "48px",
                                                height: "auto",
                                                display: "flex",
                                                flexWrap: "wrap",       
                                                alignItems: "flex-start",
                                            },
                                        }}
                                        customInputRenderer={(inputProps) => (
                                            <TextField
                                                {...inputProps}
                                                variant="outlined"
                                                fullWidth
                                                size="small"
                                                sx={{
                                                    "& .MuiInputBase-root": {
                                                        height: "48px",
                                                        fontSize: "14px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                    },
                                                }}
                                            />
                                        )}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col md='auto'>
                                    <ButtonTheme type='submit' variant="filled" color='white' className='mt-2' onClick={() => {
                                        setViewRotationModal(false)
                                    }}>
                                        Cancel
                                    </ButtonTheme>
                                </Col>

                                <Col md='auto'>
                                    <ButtonTheme type='submit' variant="filled" color='primary' className='mt-2'
                                        onClick={RotationCalled}
                                    >
                                        Update
                                    </ButtonTheme>
                                </Col>
                            </Row>
                        </Modal.Body>
                    </Modal>
                </Paper >
            )}
        </>
    )
}

export default PositionAssignment

{/* Schedule Override Button */}
{/* <Grid item xs={6} sm={6} md={'auto'}>
<Link to='/firehouse/schedule-override' style={{ textDecoration: 'none' }}>
<div className={listType == 'Schedule Override' ? 'tab-active px-4' : 'tab-white px-4'}
onClick={() => setListType('Schedule Override')}>
Schedule Override
</div>
</Link>
</Grid> */}

{/* Resource Assignment Button */}
{/* <Grid item xs={6} sm={6} md={'auto'}>
<Link to='/firehouse/resource-assignment' style={{ textDecoration: 'none' }}>
<div className={listType == 'Resource Assignment' ? 'tab-active px-4' : 'tab-white px-4'}
onClick={() => setListType('Resource Assignment')}>
Resource Assignment
</div>
</Link>
</Grid> */}

{/* <Grid item xs={12} sm={6} md={4}>
<label className='my-2'>Resource</label>
<TextField
fullWidth
variant="outlined"
onChange={(e) => setVehicle(e.target.value)}
value={resource}
placeholder="Vehicle"
sx={{
"& .MuiInputBase-root": {
height: "48px",
fontSize: "14px",
display: "flex",
alignItems: "center"
}
}}
/>
</Grid> */}

// const getAssignmentList = (loader = true) => {
//     const body = {
//         'search': searchResult,
//     }
//     if (loader) {
//         setLoading(true);
//     }
//     ApiService.post('/ra/list', body)
//         .then((data) => {
//             const rowsWithIds = data?.data?.map((item, index) => ({
//                 ...item,
//                 id: index + 1
//             })) || [];

//             setAssignmentList(rowsWithIds);
//             setLoading(false);
//         })
//         .catch((e) => {
//             setLoading(false);
//         });
// };